export const main_color = "rgb(6, 23, 72)";
export const header_table_color = "#CCE6FF";
export const active_contract_color = "#348F14";
export const inactive_contract_color = "red";
export const primary_color = "#2e3d5b";
// eslint-disable-next-line import/no-anonymous-default-export
export default {};
